document.addEventListener("DOMContentLoaded", function() {

    //adds a click event for the tooltips to display
	document.addEventListener('click', function (event) {

		//if this element has a tooltip to display
		if(typeof event.target.dataset.tooltip != 'undefined' && event.target.dataset.tooltip) {

			//if the tooltip is already active
			if(event.target.classList.contains('tooltip-active')) {

				//remove it
				remove_tooltips();
			} else { //otherwise

				//create the tooltip
				create_tooltip(event.target);
			}
		}

		if(document.body.classList.contains("tooltip-open") && !event.target.classList.contains('tooltip-active')) {
			if(!event.target.classList.contains('tooltip')) {
				//alert('tooltip');
				remove_tooltips();
			}
		}
	});

    document.addEventListener('mouseover', function (event) {
        // If this element has a tooltip to display
        if (typeof event.target.dataset.tooltip != 'undefined' && event.target.dataset.tooltip) {
            // Create the tooltip
            create_tooltip(event.target);
        }
    });

    document.addEventListener('mouseout', function (event) {
        // If this element has a tooltip to display
        if (typeof event.target.dataset.tooltip != 'undefined' && event.target.dataset.tooltip) {
            // Remove the tooltip
            remove_tooltips();
        }
    });

    //adds a keydown event for the tooltips to display
	document.addEventListener('keydown', function(event) {

		//if the escape key has been pressed and a tooltip is open
		if((event.code == "Escape" || event.code == "Esc") && document.getElementsByClassName('tooltip-active').length > 0 ) {
			remove_tooltips();
		}


	}, false);

	function create_tooltip(element) {

		//remove all existing tooltips
		remove_tooltips();

		//grab the tooltip content
		let content = element.dataset.tooltip;

		//grab any extra positioning needed
		let positioning = element.dataset.tooltip_position;

		//create a new tooltip div
		let tooltip = document.createElement('div');
			tooltip.classList = 'tooltip ' + positioning; //set our classes
			tooltip.innerHTML = content; //add the content


		//insert the tooltip after the element that called for it
		element.parentNode.insertBefore(tooltip, element.nextSibling);

		//make the tooltip visible
		element.classList.add('tooltip-active');
		document.body.classList.add("tooltip-open");
	}

	function remove_tooltips() {

		//find all active tooltips on the page (we only allow one at a a time)
		let active_tooltips = document.getElementsByClassName('tooltip-active');

		//if we have some active tooltips
		if(active_tooltips) {

			//loop over them
			for(let i = 0; i < active_tooltips.length; i++) {

				//remove the tooltip element
				active_tooltips[i].nextSibling.remove();

				//remove the active class
				active_tooltips[i].classList.remove('tooltip-active');

				// Remove active class from body
				document.body.classList.remove("tooltip-open");
			}
		}
	}
});